export { MultiSelect } from '@mantine/core'